import React, {useEffect, useState} from 'react';
import {Button, Col, Form, Icon, Input, message, Row} from "antd";
import ProfilePersonalForm from "./ProfilePage/ProfilePersonalForm";
import ProfileContactForm from "./ProfilePage/ProfileContactForm";
import useApi from "../../../../Hooks/Api";
import useAuth from "../../../../Hooks/Auth";
import Loading from "../../../Generic/Loading";
import moment from "moment";
import Modal from "antd/es/modal";
import {useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import {Images} from "../../../../Helpers/Images";
import GenericInput from "../../../Generic/GenericInput";
import * as md5 from "md5";


const ProfilePage = props => {
    const api = useApi();
    const [user, setUser] = useState({});
    const [loading,setLoading] = useState(true);
    const {validateFields} = props.form;
    const {logoutWithoutApi} = useAuth();

    const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
    const [oldPassword, setOldPassword] = useState(undefined);
    const [newPassword, setNewPassword] = useState(undefined);
    const [newPasswordConfirmation, setNewPasswordConfirmation] = useState(undefined);

    const [showDisableAccountModal, setShowDisableAccountModal] = useState(false);
    const [cpf, setCpf] = useState(undefined);
    const profile = useSelector(state => state).authReducer;
    const history = useHistory();

    const getData = async () => {
        setLoading(true);
        api.get(`user/${profile.user_id}/full`,(res) => {
            setUser(res);
            setLoading(false);
        }, (e) => {
            message.error('Ops, não foi possível recuperar seu perfil, tente novamente');
        });
    }

    const handleSubmit = async () => {
        validateFields(async (error, values) => {
            if (error) return 0;
            else {
                values.birthday = moment(values.birthday).format('YYYY-MM-DD');
                api.post(`user/${profile.user_id}/profile`, values, (res) => {
                    message.success('Seus dados foram alterados com sucesso!');
                }, (e) => {
                    message.error(e.message || 'Ops!, não foi possível salvar seus dados')
                });
            }
        });
    };

    const changePassword = async () => {
        if(newPassword === newPasswordConfirmation) {
            if (oldPassword && newPassword) {
                api.post('user/change-password', {
                    old_password: md5(oldPassword),
                    password: md5(newPassword)}, (res) => {
                    message.success('Senha alterada com sucesso!');
                    setShowChangePasswordModal(false);
                }, (e) => {
                    message.error(e.message || 'Ops!, não foi possível salvar seus dados')
                });
            } else {
                message.error( 'Ops!, insira a senha atual e a nova senha')
            }
        } else {
            message.error( 'Ops!, sua nova senha e a confirmação da nova senha devem ser iguais')
        }

    };

    const disableAccount = async () => {
        if(cpf === profile.cpf) {
            api.post('access/disable-account', {cpf}, (res) => {
                message.success('Sua conta foi desabilitada.', 'Para habilitar novamente entre em contato conosco!');
                logoutWithoutApi();
            }, (e) => {
                console.log(e);
                message.error( e.message || 'Não foi possível desabilitar sua conta, tente novamente');
            });
        } else {
            message.error('Por favor, para desabilitar insira o seu CPF');
        }
    };


    useEffect(() => {
        getData()
       /* return GlobalVariables.sidebar = false;*/
    },[]);


    return (
        <Row className={'mainComponentPanel'} style={{display: 'flex', flexFlow: 'column', justifyContent: 'center'}}>
            <Modal
                className={'defaultModal defaultModalBlue'}
                destroyOnClose
                style={{textAlign: 'center'}}
                visible={showChangePasswordModal}
                onCancel={() => {setShowChangePasswordModal(false)}}
                footer={null}>
                <div>
                    <div style={{marginBottom: 30}}>
                        <span style={{fontSize: 25, textAlign: 'center', fontWeight: 'bold'}}> Você está prestes a trocar a sua senha. </span>
                    </div>


                    <Form.Item
                        className={'hideDots'}
                        style={{borderBottom: '1px solid gainsboro', paddingBottom: 25}}
                        label={<span style={{ color: 'rgba(0, 0, 0, 0.65)', fontSize: 16}}><strong>Sua senha atual </strong> </span>}
                    >
                        <Input.Password value={oldPassword}  onChange={(e) => {setOldPassword(e.target.value)}} placeholder={'Senha atual'} size={'large'}/>
                    </Form.Item>

                    <Form.Item
                        className={'hideDots'}
                        label={<span style={{ color: 'rgba(0, 0, 0, 0.65)', fontSize: 16}}><strong>Sua nova senha</strong> </span>}
                    >
                        <Input.Password value={newPassword} onChange={(e) => {setNewPassword(e.target.value)}} placeholder={'Nova senha'} size={'large'}/>
                    </Form.Item>

                    <Form.Item
                        className={'hideDots'}
                        label={<span style={{ color: 'rgba(0, 0, 0, 0.65)', fontSize: 16}}><strong>Confirme sua nova senha</strong> </span>}
                    >
                        <Input.Password value={newPasswordConfirmation} onChange={(e) => {setNewPasswordConfirmation(e.target.value)}} placeholder={'Confirme a nova senha'} size={'large'}/>
                    </Form.Item>

                    <Button icon={'check'} disabled={api.loading} loading={api.loading} style={{marginTop: 30}} onClick={() => changePassword()}
                            className={'saveButton'} size={'large'} type={'primary'}>
                        Trocar senha
                    </Button>
                </div>
            </Modal>

            <Modal
                className={'defaultModal defaultModalBlue'}
                destroyOnClose
                style={{textAlign: 'center'}}
                visible={showDisableAccountModal}
                onCancel={() => {setShowDisableAccountModal(false)}}
                footer={null}>
                <div>
                    <div style={{marginBottom: 30}}>
                        <span style={{fontSize: 25, textAlign: 'center', fontWeight: 'bold', }}> Você está prestes a desabilitar a sua conta, você perderá acesso a todos os seus dados. </span>
                    </div>

                    <Input value={cpf} onChange={(e) => setCpf(e.target.value)} placeholder={'Seu CPF'} size={'large'}/>

                    <Button icon={'check'} disabled={api.loading} loading={api.loading} style={{marginTop: 30}} onClick={() => disableAccount()}
                            className={'saveButton'} size={'large'} type={'danger'}>
                        Desabilitar
                    </Button>
                </div>
            </Modal>


            <div className={'back-side-button'} onClick={() => history.push('/painel')}>
                <Icon className={'craftyIcon'} type={'arrow-left'}/>
                <span> Voltar </span>
            </div>
            {loading?
                <div style={{margin: "auto"}}> <Loading/> </div>
                :
                <>
                    <Col span={24} style={{padding: 10}}>
                        <ProfilePersonalForm getData={() => getData()} user={user.profile} form={props.form}/>
                    </Col>
                    <Col span={24}  style={{padding: 10}}>
                        <ProfileContactForm user={user.profile} form={props.form}/>
                    </Col>
                    <Col span={24}>
                        <div style={{display: 'flex', justifyContent: 'space-between', padding: 10}}>
                            <div>
                                <Button color={'red'} icon={'alert'} style={{marginRight: 10}} disabled={api.loading} loading={api.loading} onClick={() => setShowDisableAccountModal(true)}
                                        className={'saveButton'}>
                                    Desabilitar Perfil
                                </Button>

                                <Button icon={'lock'} disabled={api.loading} loading={api.loading} onClick={() => setShowChangePasswordModal(true)}
                                        className={'saveButton'} type={'primary'}>
                                    Trocar senha
                                </Button>
                            </div>

                            <Button icon={'check'} disabled={api.loading} loading={api.loading} onClick={() => handleSubmit()}
                                    className={'saveButton'} type={'secondary'}>
                                Salvar alterações
                            </Button>
                        </div>
                    </Col>
                </>
            }
        </Row>
    );
};

ProfilePage.propTypes = {};

export default Form.create({name: 'form_profile'})(ProfilePage);
